<template>
  <div class="result">
    <div class="wrap">
      <img src="@/assets/images/success.png" alt=""/>
      <div class="item">
        <p >恭喜您，<br />您购买的是正品，请放心食用</p>
      </div>
      <div class="footer">
        <div class="footer-content">
          <span>您查询的溯源验证码为</span>
          <div><p style="word-break: break-all;">{{verificationValue}}</p></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      verificationValue: '',
      info:{}
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  async created() {
    //  
    this.verificationValue =  this.$route.query.defaultId
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
  },
  //方法
  methods: {},
};
</script>
<style lang="scss" scoped>
p{
  margin: 0;
}
.result {
  padding: 48px 32px;
  box-sizing: border-box;
  background: #f5f5f5;
  height: 100%;
  width: 100%;

  .wrap {
    width: 686px;
    height: 1110px;
    box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    background: #fff;

    img {
      margin: 144px 264px 48px;
      width: 160px;
      height: 160px;
    }

    .item {
      text-align: center;
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 48px;
      color: #222222;
    }

    .footer {
      width: 590px;
      height: 144px;
      margin: 64px auto;
      background: rgb(245, 245, 245);
      opacity: 1;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      .footer-content {
        text-align: center;
        font-size: 28px;
        line-height: 44px;

        div {
          color: #26907a;
        }

      }
    }
  }
}
</style>
